import { httpClient } from "@services/api/httpClient";

export interface IGetUserRelatedFromBuilderInput {
    uuid: string;
}

export const getUserRelatedFromBuilder = async (input: IGetUserRelatedFromBuilderInput) => {
    const response = await httpClient.post("/auth/get-user-related-from-builder", input);
    return response.data;
}